document.querySelectorAll('.single-formation-tabs__button').forEach(button => {
    button.addEventListener('click', () => {
        const tab = button.dataset.tab;

        document
            .querySelectorAll('.single-formation-tabs__button, .single-formation-tabs__content')
            .forEach(el => el.classList.remove('is-active'));

        button.classList.add('is-active');
        document
            .querySelector(`.single-formation-tabs__content[data-tab="${tab}"]`)
            .classList.add('is-active');
    });
});